/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Location} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnInit, Optional} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NbWindowRef} from '@nebular/theme';
import {DamShare, FileService} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../admin-shared/crud-components/create-update/create-update.component';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {FormConfigService} from '../../../admin-shared/services/form-config.service';
import {DamService} from '../dam.service';
import {DAM_SHARE_FORM} from './dam-share-forms.config';

@Component({
  selector: 'app-dam-share',
  templateUrl: './dam-share.component.html',
  styleUrls: ['./dam-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamShareComponent extends CreateUpdateComponent<DamShare> implements OnInit {

  shareUrl = '';

  constructor(protected readonly formConfigService: FormConfigService,
              protected readonly route: ActivatedRoute,
              protected readonly location: Location,
              @Optional() protected readonly windowRef: NbWindowRef,
              protected readonly fileService: FileService,
              protected readonly damService: DamService,
  ) {
    super(formConfigService, route, location, windowRef, fileService);
  }

  title = 'Поделиться';
  protected uri = '/dam-share/items';
  absolutePath = '/cabinet/dam-share';
  model: any;
  isModal = true;
  protected entity: any;
  config: CrudConfig = {
    uri: this.uri,
    columns: DAM_SHARE_FORM,
    title: this.title,
    absolutePath: this.absolutePath,
  };

  @Input()
  damItems: number[] = [];

  @Input()
  damCatalog: number;

  @Input()
  shareType: number;

  ngOnInit(): void {
    super.setConfig(this.config);
    super.ngOnInit();
    this.model.startDate = null;
    this.model.endDate = null;
    console.log(this.damItems);
    console.log(this.damCatalog);
    console.log(this.shareType);
    this.redirectToEditPage = true;
    this.cdr.detectChanges();
  }

  beforeSubmit(): void {
    this.entity = {};
    this.entity.id = this.model.id;
    this.entity.header = this.model.header;
    this.entity.damCatalogId = this.damCatalog;
    this.entity.shareType = this.shareType;
    this.entity.damItems = Array.from(this.damItems);
    console.log(typeof this.model.startDate);

    this.entity.startDate = this.model.startDate === null ? null : this.convertDate(this.model.startDate);
    this.entity.endDate = this.model.endDate === null ? null : this.convertDate(this.model.endDate);
    this.entity.enabled = this.model.enabled;
    console.log(typeof this.entity.startDate);
    console.log(this.entity);
  }

  afterSubmit(): void {
    this.shareUrl = this.createdId;
    this.cdr.detectChanges();
  }

  private convertDate(date: Date): string {
    const ye = new Intl.DateTimeFormat('ru', {year: 'numeric'}).format(date);
    const mo = new Intl.DateTimeFormat('ru', {month: '2-digit'}).format(date);
    const da = new Intl.DateTimeFormat('ru', {day: '2-digit'}).format(date);

    return ye + '-' + mo + '-' + da;
  }

  copyShareUrl(shareUrl) {
    navigator.clipboard.writeText(shareUrl).then(item => {
      this.successToast(translations.copiedToClipboard);
    });
  }
}
